import { Flex } from "@chakra-ui/react";
import { formatMoney } from "infra/helpers/number";
import { CobrancaContaItem } from "features/cobranca/typings";

interface TableTotalRowProps {
  conta: CobrancaContaItem;
}

function TableTotalRow({ conta }: TableTotalRowProps) {
  return (
    <>
      <Flex flex={2} ml={4}></Flex>
      <Flex flex={1} justifyContent="flex-end">
        {formatMoney(conta?.valor)}
      </Flex>
      <Flex flex={1} justifyContent="flex-end" gap={2}>
        {formatMoney(conta?.multa)}
      </Flex>
      <Flex flex={1} justifyContent="flex-end" gap={2}>
        {formatMoney(conta?.juros)}
      </Flex>
      <Flex flex={1} justifyContent="flex-end" gap={2}>
        {formatMoney(conta.valorTaxaCobranca)}
      </Flex>
      <Flex flex={1} justifyContent="flex-end">
        {formatMoney(conta?.atualizacaoMonetaria)}
      </Flex>
      {/* <Flex flex={1} justifyContent="flex-end">
        {formatMoney(conta?.honorarios)}
      </Flex> */}
      <Flex flex={1} justifyContent="flex-end">
        {formatMoney(conta?.total)}
      </Flex>
    </>
  );
}

export default TableTotalRow;
